import { render, staticRenderFns } from "./AdjuntarDocumentacion.vue?vue&type=template&id=76b68ce1"
import script from "./AdjuntarDocumentacion.vue?vue&type=script&lang=js"
export * from "./AdjuntarDocumentacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports